var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5C16.3556 22.5 20.0584 19.7159 21.4307 15.8332C21.6148 15.3125 21.3418 14.7412 20.8211 14.5572C20.3004 14.3731 19.7291 14.646 19.545 15.1668C18.4463 18.2753 15.4817 20.5 12 20.5C7.58172 20.5 4 16.9183 4 12.5C4 8.08172 7.58172 4.5 12 4.5C13.5516 4.5 14.8662 5.06117 16.1162 5.9406C16.9569 6.53212 17.7348 7.24106 18.5242 8H15.5C14.9477 8 14.5 8.44772 14.5 9C14.5 9.55228 14.9477 10 15.5 10H21C21.5523 10 22 9.55228 22 9V3.5C22 2.94772 21.5523 2.5 21 2.5C20.4477 2.5 20 2.94772 20 3.5V6.64371C19.1517 5.82583 18.2456 4.99337 17.267 4.30489C15.7949 3.26916 14.0847 2.5 12 2.5Z",
    fill: "#03071275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCw);
export default __webpack_public_path__ + "static/media/arrow-cw.fc3c26432b87c16702c62bf2b46368ef.svg";
export { ForwardRef as ReactComponent };